import Styles from '../../../Styles';
import Localized from 'src/constants/AppStrings';
import PaperBill from 'src/components/img/svg/cards/paperBill';
import AVText from 'src/components/elements/AVText';
import {View} from 'react-native';
import PaperBillRedeisgn from '../../../img/svg/cards/paperBillRedesign';
import React from 'react';
import WarningIconSnackDetails from '../../../img/svg/WarningIconSnackDetails';
import {getDescriber} from '../../../elements/descriptor/DescriptorType';

export function getPayrollDeductAgreementTxt() {
  return {
    textAlign: 'left',
    fontWeight: 'bold',
    color: Styles.Colors.Aramark.primary,
  };
}
export function getPayrollDeductAgreementUnderline() {
  return null;
}
export function getCreditCardAddStyleDescriptor(): {
  [index: string]: {
    [index: string]:
      | number
      | string
      | Array<{scaleX?: number; scaleY?: number}>;
  };
} {
  return {
    defaultSwitch: {
      transform: [
        {
          scaleX: 0.85,
        },
        {
          scaleY: 0.85,
        },
      ],
    },
    inputsContainer: {
      paddingHorizontal: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m2,
      flexDirection: 'column',
    },
  };
}
export function getPayrollDeductPendingDescStyle() {
  return {textAlign: 'left'};
}
export function getPayrollDeductPendingTitleStyle() {
  return {
    textAlign: 'left',
    fontWeight: 'bold',
    marginBottom: Styles.Spacing.m12,
  };
}
export function getPayrollDeductImageStyle() {
  return {
    alignItems: 'flex-start',
    marginLeft: -8,
    marginTop: -5,
    height: 40,
    width: 50,
  };
}
export function getPayRollDeductImage() {
  return (
    <PaperBill
      lineColor={Styles.Colors.Aramark.primary}
      size={Styles.Fonts.f5}
      style={{size: {width: 60, height: 60}}}
    />
  );
}
export function getAcntFundingHeaderStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    headerNewContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderTopRightRadius: 10,
      backgroundColor: Styles.white,
      paddingHorizontal: Styles.Spacing.m3,
      borderTopLeftRadius: 10,
    },
  };
}

export function normalPayrollAggreement() {
  return null;
}

export function getResetLbl() {
  return null;
}
export function getOptinTxt() {
  return {fontWeight: 'bold'};
}
export function getModalTexts(): {
  [index: string]: number | string;
} {
  return {
    fundModalHeaderTitle: Localized.Labels.quick_fund_your_account_redesign,
  };
}
export function getOptingOutPayrollDeduct() {
  return {
    fontSize: Styles.Fonts.f8,
    color: Styles.Colors.Aramark.black01,
    fontFamily: Styles.FontFamily.gothamRegular,
    textAlign: 'left',
  };
}

export function getOptingOutPayrollDeductContent(styles, isOptIn) {
  return (
    <>
      {isOptIn ? (
        <AVText
          style={[styles.infoText, getOptingOutPayrollDeduct()]}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
        >
          {Localized.Labels.opting_out_of_payroll_deduct}
        </AVText>
      ) : (
        <View
          style={[
            styles.referralSuccErrView,
            styles.flexRowContainer,
            {
              backgroundColor: '#d7263d26',
              marginTop: 24,
              marginBottom: 24,
            },
          ]}
        >
          <View style={styles.flexLeft}>
            <WarningIconSnackDetails />
          </View>
          <View style={styles.flexRight}>
            <AVText
              style={{
                fontFamily: getDescriber().walletForntStyleText(),
                fontWeight: '400',
                color: '#111',
                fontSize: Styles.Fonts.f8,
              }}
            >
              <AVText style={[styles.referralTextDesc]}>
                {Localized.Labels.opt_out}
              </AVText>
              {Localized.Labels.opt_out_desc}
            </AVText>
          </View>
        </View>
      )}
    </>
  );
}

export function getOptinView() {
  return {justifyContent: 'flex-start', gap: Styles.Spacing.m1};
}
export function getFilledColor() {
  return Styles.Colors.Aramark.primary;
}
export function getSwitchColor() {
  return {
    false: Styles.lightGray,
    true: Styles.primaryColor,
  };
}
export function getUnfilledColor() {
  return Styles.neutralHues;
}
export function getSpendLimit() {
  return {fontWeight: 'bold'};
}
export function getRemainingStyle() {
  return null;
}
export function switchStyle() {
  return null;
}

export function payrollDeductNormlSectionImage(styles) {
  return (
    <View
      style={[
        styles.iconContainer,
        getPayrollDeductImageStyle(),
        {
          marginLeft: -5,
        },
      ]}
    >
      <PaperBillRedeisgn lineFillColor={'#D23580'} size={Styles.Fonts.f5} />
    </View>
  );
}
export default {
  getPayrollDeductPendingTitleStyle,
  getPayrollDeductImageStyle,
  switchStyle,
  getOptinTxt,
  payrollDeductNormlSectionImage,
  getPayRollDeductImage,
  getSpendLimit,
  getOptingOutPayrollDeductContent,
  getFilledColor,
  getPayrollDeductAgreementUnderline,
  getPayrollDeductPendingDescStyle,
  getCreditCardAddStyleDescriptor,
  normalPayrollAggreement,
  getRemainingStyle,
  getSwitchColor,
  getUnfilledColor,
  getModalTexts,
  getOptinView,
  getAcntFundingHeaderStyleDescriptor,
  getPayrollDeductAgreementTxt,
  getOptingOutPayrollDeduct,
  getResetLbl,
};
